<template>
    <div class="news-mask" v-if="show">
        <div class="news-box">
            <span class="news-box-icon"></span>
            <span class="news-box-icon"></span>
            <span class="news-box-icon"></span>
            <span class="news-box-icon"></span>
            
            <span class="news-box-closebtn iconfont iconguanbi" @click="closeNews"></span>

            <div class="news-header">
                <div class="news-header-box">
                    <p class="news-header--time">{{ $utils.formatTime(newContent.publishedAt) }}</p>
                    <p class="news-header--type">{{formatNewsCategory(newContent.category)}}</p>
                </div>
                <p class="news-header--title">『{{ newContent.title }}』</p>
            </div>
            <div class="news-content" v-html="newContent.content[0].value"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: "news-mask",
    props: ['show'],
    components: {

    },
    data: () => ({
    }),
    created() {

    },
    mounted() {

    },
    watch: {
        show(val) {
            this.HOME_FULLPAGE.scrollDisable = val      // 禁用滚动
        }
    },
    computed: {
        HOME_FULLPAGE() {
            return this.$store.state.HOME_FULLPAGE;
        },
        newContent() {
            console.log(this.$store.state.NEWS_CONTENT)
            return this.$store.state.NEWS_CONTENT
        }
    },
    methods: {
        closeNews() {
            this.$store.commit("SET_NEWS", {
                status: false,
                conetnt: ""
            })
        },
        formatNewsCategory(index) {
            switch (index) {
                case 1:
                    return "お知らせ"
                    break;
                case 2:
                    return "イベント"
                    break;
                case 3:
                    return "アップデート"
                    break;
                case 4:
                    return "メンテナンス"
                    break;
                default:
                    break;
            }
        }
    },
};
</script>

<style lang="scss" scoped>
.news-mask {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 999;
    background: rgba(0,0,0,.3);

    .news-box {
        width: 50%;
        height: 85%;
        background:#D1D1D1 url("../assets/images/home/page02/news_mask_bg.png") no-repeat;
        background-size: cover;
        background-position: center;
        border-radius: 8px;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
        box-sizing: border-box;
        border: 2px solid #696d70;
        padding: pxTorem(30px) pxTorem(30px);
        display: flex;
        flex-direction: column;

        .news-box-icon {
            width: pxTorem(35.2px);
            height: pxTorem(40px);
            background: url("../assets/images/home/page02/news_mask_icon.png") no-repeat;
            background-size: 100%;
            position: absolute;

            &:nth-of-type(1) {
                left: 2px;
                top: 2px;
                transform: scale(-1, 1);
            }
            &:nth-of-type(2) {
                right: 2px;
                top: 2px;
            }
            &:nth-of-type(3) {
                left: 2px;
                bottom: 2px;
                transform: scale(-1, -1);
            }
            &:nth-of-type(4) {
                right: 2px;
                bottom: 2px;
                transform: scale(1, -1);
            }
        }

        .news-box-closebtn {
            position: absolute;
            width: pxTorem(65px);
            height: pxTorem(65px);
            background: #000;
            border-radius: 50%;
            right: -15%;
            color: #fff;
            font-size: pxTorem(34px);
            line-height: pxTorem(65px);
            text-align: center;
            cursor: pointer;

            &:hover {
                background: #189c8f;
            }
        }

        .news-header {
            width: 100%;
            min-height: pxTorem(100px);
            border-bottom: 1px dashed #757575;
            display: flex;
            flex-direction: column;
            margin-bottom: pxTorem(20px);

            .news-header-box {
                display: flex;
                flex-direction: row;
                align-items: center;
                
                .news-header--time {
                    font-size: pxTorem(26px);
                }
                .news-header--type {
                    font-size: pxTorem(16px);
                    margin-left: pxTorem(10px);
                    padding: pxTorem(3px) pxTorem(5px);
                    border: 1px solid #000;
                }
            }
            .news-header--title {
                color: #4582f0;
                max-width: 100%;
                overflow: hidden;
                text-overflow:ellipsis;
                white-space: nowrap;
                font-size: pxTorem(29px);
                margin-top: pxTorem(10px);
            }
        }
        .news-content {
            flex: 1;
            width: 100%;
            overflow-y: auto;
            font-size: pxTorem(16px) !important;
            
            &::-webkit-scrollbar {
                width: 8px;
            }
            &::-webkit-scrollbar-track {
                background-color: transparent;
            }
            &::-webkit-scrollbar-thumb {
                background-color: #8fc2ff;
                border-radius: 5px;
            }
            // ie
            scrollbar-face-color: #8fc2ff;
            scrollbar-track-color: transparent;
            scrollbar-highlight-color: #292F33;
            scrollbar-base-color:#8fc2ff;

            & /deep/ img {
                max-width: 100%;
                height: auto !important;
            }
        }
    }
}
</style>
